// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-a-index-js": () => import("./../../../src/pages/a/index.js" /* webpackChunkName: "component---src-pages-a-index-js" */),
  "component---src-pages-cactus-app-js": () => import("./../../../src/pages/cactus-app.js" /* webpackChunkName: "component---src-pages-cactus-app-js" */),
  "component---src-pages-client-index-js": () => import("./../../../src/pages/client/index.js" /* webpackChunkName: "component---src-pages-client-index-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-reflect-reset-js": () => import("./../../../src/pages/reflect-reset.js" /* webpackChunkName: "component---src-pages-reflect-reset-js" */),
  "component---src-pages-trial-js": () => import("./../../../src/pages/trial.js" /* webpackChunkName: "component---src-pages-trial-js" */)
}

